var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute shadow-lg z-50 transform bg-dropdown overflow-hidden",class:_vm.positions,attrs:{"id":_vm.popupId}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }